<template>
	<div class="title-line">
		<h4 class="title-between-line">{{ title }}</h4>
	</div>
</template>

<script>
  export default {
    name: 'SectionTitle',
    props: {
      title: {
        type: String,
        required: true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// resources/js/app/components/SectionTitle.vue